import { CartDrawer } from "~/rs-components/global/CartDrawer.client"
import { contactInfo, header } from "../settings"
import PhoneHeader from "~/assets/icons/PhoneHeader";
import CartIcon from "~/assets/icons/CartIcon";
import FacebookIcon from "~/assets/icons/FacebookIcon";
import InstagramIcon from "~/assets/icons/InstagramIcon";
import LinkedinIcon from "~/assets/icons/LinkedinIcon";
import PinterestIcon from "~/assets/icons/PinterestIcon";
import TwitterIcon from "~/assets/icons/TwitterIcon";
import UserIcon from "~/assets/icons/UserIcon";
import YoutubeIcon from "~/assets/icons/YoutubeIcon";
import CartBadge from "~/rs-components/global/header/CartBadge.client";

interface SetupActivityBrandProp {
    isCartOpen: boolean;
    closeCart: () => void;
    openCart: () => void;
    currency: string;
}


export default function SetupActivityBar({ isCartOpen, closeCart, openCart, currency }: SetupActivityBrandProp) {
    return (
        <>
            <CartDrawer currency={currency} isOpen={isCartOpen} onClose={closeCart} />
            {header.activityBar.show &&
                <div className="NotificationPromo">
                    <div className="NotificationPromo__container">
                        <div className="NotificationPromo__text__side">
                            {header.activityBar.socialButtons &&
                                <div className="headerLeftLogo__topArea">
                                    <div className="topUserArea loginCart text-right">
                                        <a className="iconsInformation__call" href={`tel:${contactInfo.phone}`}><PhoneHeader /> <span className="text-white ml-2 mr-4">{contactInfo.phone}</span></a>
                                        {contactInfo.facebook && contactInfo.facebook != 'facebook' && <a href={contactInfo.facebook} target="_blank"><FacebookIcon transparent /></a>}
                                        {contactInfo.instagram && contactInfo.instagram != 'instagram' && <a href={contactInfo.instagram} target="_blank"><InstagramIcon transparent /></a>}
                                        {contactInfo.twitter && contactInfo.twitter != 'twitter' && <a href={contactInfo.twitter} target="_blank"><TwitterIcon transparent /></a>}
                                        {contactInfo.pinterest && contactInfo.pinterest != 'pinterest' && <a href={contactInfo.pinterest} target="_blank"><PinterestIcon transparent /></a>}
                                        {contactInfo.youtube && contactInfo.youtube != 'youtube' && <a href={contactInfo.youtube} target="_blank"><YoutubeIcon transparent /></a>}
                                        {contactInfo.linkedin && contactInfo.linkedin != 'linkedin' && <a href={contactInfo.linkedin} target="_blank"><LinkedinIcon transparent /></a>}
                                    </div>
                                </div>
                            }
                        </div>
                        <div className="NotificationPromo__text">
                            <p><span> {header.activityBar.span} </span> {header.activityBar.p} </p>
                        </div>
                        <div className="NotificationPromo__text__side">
                            {header.activityBar.showActionButtons &&
                                <div className="headerLeftLogo__topArea">
                                    <div className="topUserArea loginCart text-right">
                                        <div className="topUserArea__login">
                                            <a href='/account'><UserIcon /></a>
                                        </div>
                                        <button onClick={openCart} className='relative flex items-center justify-center w-8 h-8'>
                                            <CartIcon />
                                            <CartBadge />
                                        </button>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }
        </>

    )
} 